<template>
  <div class="moduleContainer">
    <div class="header">
      <div class="title">
        <i class="el-icon-s-opportunity"></i>
        用户动态
      </div>
      <div>
        <!-- class="operations" -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-select v-model="SearchData.module" multiple placeholder="请选择模块" size="small" clearable @change="
              catchModule();
            GetTableList(true);
            " @clear="
              catchModule();
            GetTableList(true);
            ">
              <el-option v-for="item in moduleList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-input placeholder="请输入用户手机号" size="small" v-model="SearchData.phone" clearable
              @clear="GetTableList(true)" @keyup.enter.native="GetTableList(true)">
            </el-input>
          </el-col>
          <el-col :span="8">
            <el-select v-model="SearchData.tenant_id" filterable clearable remote reserve-keyword
              placeholder="输入企业名进行筛选" size="small" :remote-method="remoteMethod" @change="GetTableList(true)">
              <el-option v-for="item in tenant_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px">
          <el-col :span="12">
            <el-date-picker v-model="SearchData.dateRange" size="small" type="daterange" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="GetTableList(true)">
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <el-select style="margin-left: 10px" v-model="SearchData.manager_id" clearable placeholder="根据业务员筛选"
              size="small" @change="GetTableList(true)">
              <el-option v-for="manager of managerList" :key="manager.id" :label="manager.display_name"
                :value="manager.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-checkbox style="margin-left: 50px" v-model="SearchData.not_read" true-label="1" false-label="0"
              @change="GetTableList(true)">仅显示未读动态</el-checkbox>
          </el-col>
          <!-- <el-button plain style="margin-left: 50px" @click="bulk_read"
          >本页全部已读</el-button
        > -->
        </el-row>
      </div>
    </div>
    <div class="businessList">
      <el-table :data="TableList" :stripe="false" :row-class-name="tableRowClassName"
        @selection-change="HandleSelectionChange" @sort-change="HandleSortChange" style="box-shadow: none">
        <!-- FIXME -->
        <TableOperation :operationList="[
          {
            is_show: (row) => true,
            label: '处理',
            command: 'change_read',
          },
          {
            is_show: (row) => !row.is_top,
            label: '置顶',
            command: 'change_top',
          },
          {
            is_show: (row) => row.is_top,
            label: '取消置顶',
            command: 'change_top',
          },
        ]" @handleOperation="HandleOperation" />

        <el-table-column label="企业" width="150">
          <el-table-column label="用户" width="150">
            <template slot-scope="scope">
              <div>
                <el-tooltip v-if="scope.row.tenant && scope.row.tenant.credit_rating <= 2" effect="dark"
                  placement="top">
                  <div slot="content" style="width:200px">
                    <div v-if="scope.row.tenant.credit_rating == 0">
                      <span class="color-danger">{{ $store.state.basicInfo.credit_ratingList[0].tip_title }}:</span>{{
                        $store.state.basicInfo.credit_ratingList[0].tip_content_business }}
                    </div>
                    <div v-else-if="scope.row.tenant.credit_rating == 1">
                      <span class="color-warning">{{ $store.state.basicInfo.credit_ratingList[1].tip_title }}:</span>{{
                        $store.state.basicInfo.credit_ratingList[1].tip_content_business }}
                    </div>
                    <div v-else-if="scope.row.tenant.credit_rating == 2">
                      <span class="color-success">{{ $store.state.basicInfo.credit_ratingList[2].tip_title }}:</span>{{
                        $store.state.basicInfo.credit_ratingList[2].tip_content_business }}
                    </div>
                  </div>
                  <div class="credit_level_info" :class="{
                    'danger': scope.row.tenant.credit_rating == 0,
                    'warning': scope.row.tenant.credit_rating == 1,
                    'success': scope.row.tenant.credit_rating == 2,
                  }">
                    <i class="el-icon-warning"></i>
                    {{
                      $utils.listFilter(
                        $store.state.basicInfo.credit_ratingList,
                        scope.row.tenant.credit_rating
                      )
                    }}
                  </div>
                </el-tooltip>
              </div>
              <div>

                <template v-if="scope.row.tenant">
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">{{ scope.row.tenant.name }}</div>
                    <div class="one_lines">{{ scope.row.tenant.name }}</div>
                  </el-tooltip>
                </template>
                <template v-else-if="scope.row.user && scope.row.user.pre_company_name">
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">
                      {{
                        $utils.listFilter(
                          $store.state.basicInfo.tagList.business_1,
                          scope.row.user.pre_business_tag_id
                        )
                      }}
                      {{ scope.row.user.pre_company_name }}
                    </div>
                    <div class="one_lines" style="color: #ccc">
                      {{
                        $utils.listFilter(
                          $store.state.basicInfo.tagList.business_1,
                          scope.row.user.pre_business_tag_id
                        )
                      }}
                      {{ scope.row.user.pre_company_name }}
                    </div>
                  </el-tooltip>
                </template>
                <template v-else> - </template>
              </div>
              <div>
                <template v-if="scope.row.user">
                  <el-tooltip class="item" effect="dark" placement="right">
                    <div slot="content">
                      <!-- {{ scope.row.user.display_name }} -->
                      {{ scope.row.user.mobile }}
                    </div>
                    <div class="one_lines">
                      <!-- {{ scope.row.user.display_name }} -->
                      {{ scope.row.user.mobile }}
                    </div>
                  </el-tooltip>
                </template>
                <!-- 没有user不一定是游客用户，也可能是后管做的操作，如为用户开通会员 -->
                <template v-else> - </template>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="模块编号">
          <el-table-column label="用户行为">
            <template slot-scope="scope">
              <div>
                【{{ $utils.listFilter(moduleList, scope.row.module) }}】
                <span :class="{ ViewLink: transformTarget(scope.row) }" @click="goTransformTarget(scope.row)">
                  {{ scope.row.rewrite_record_sign || scope.row.record_sign }}
                </span>
              </div>

              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">{{ scope.row.info }}</div>
                <!-- class="one_lines" -->
                <div>
                  {{ scope.row.info }}
                  <template v-if="scope.row.info_img_array">
                    <el-image style="width:100px;height:100px;margin-right:5px;"
                      v-for="item of scope.row.info_img_array" :key="item" :src="item" fit="contain"
                      :preview-src-list="scope.row.info_img_array"></el-image>
                  </template>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="动态时间" width="150">
          <el-table-column label="责任人" width="150">
            <template slot-scope="scope">
              <div>{{ scope.row.created_time.slice(0, 16) }}</div>
              <div class="one_lines">
                <template v-if="scope.row.event_type">管理员</template>
                <template v-else-if="scope.row.manager">
                  {{ scope.row.manager.display_name }}
                </template>
                <template v-else>-</template>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="处理时间" width="150">
          <el-table-column label="处理结果" width="150">
            <template slot-scope="scope">
              <template v-if="scope.row.updated_time">
                <div>{{ scope.row.updated_time.slice(0, 16) }}</div>
                <el-tooltip class="item" effect="dark" placement="left">
                  <div slot="content">{{ scope.row.remark }}</div>
                  <div class="one_lines">{{ scope.row.remark || "-" }}</div>
                </el-tooltip>
              </template>
              <div v-else class="color-danger">待处理</div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-pagination v-if="TotalCount" style="margin-top: 30px; justify-content: center" background
        @size-change="HandleSizeChange" @current-change="HandleCurrentChange" :current-page="CurrentPage"
        :page-sizes="PageSizeList" :page-size="PageSize" layout="total, prev, pager, next, jumper"
        :total="TotalCount"></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
export default {
  name: "MessageList",
  mixins: [tableMixin],
  props: {
    managerList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      SearchData: {
        module: this.$localStorage.get("admin_message_module")
          ? this.$localStorage.get("admin_message_module").split(",")
          : [],
        tenant_id: "",
        manager_id: "",
        not_read: "0",
        // is_unread_top: "true",
        phone: "",
        dateRange: null,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      ScrollAfterChange: false,
      moduleList: [
        {
          name: "申请反馈",
          id: "accusation",
        },
        {
          name: "导出任务",
          id: "task",
        },

        {
          name: "用户",
          id: "user",
        },
        {
          //认证成功也在tenant里
          name: "企业",
          id: "tenant",
        },
        // {
        //   name: "企业认证",
        //   id: "tenant_authentication",
        // },
        {
          name: "现货卖场-发布",
          id: "quotation",
        },
        {
          name: "现货卖场-询价",
          id: "business_quotation",
        },

        {
          name: "锻件定制-发布",
          id: "purchase_forging",
        },
        {
          name: "锻件定制-报价",
          id: "business_purchase_forging",
        },

        {
          name: "原料求购-发布",
          id: "purchase_material",
        },
        {
          name: "原料求购-报价",
          id: "business_purchase_material",
        },

        {
          name: "钢厂拼单-参与",
          id: "business_raise",
        },

        {
          name: "零切交易-发布",
          id: "purchase_piece",
        },
        {
          name: "零切交易-报价",
          id: "business_purchase_piece",
        },
        {
          name: "机加工-发布",
          id: "purchase_machining",
        },
        {
          name: "机加工-报价",
          id: "business_purchase_machining",
        },
        {
          name: "周边论坛-帖子",
          id: "forum",
        },
      ],
      tenant_list: [],
    };
  },
  created() {
    this.remoteMethod();
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      let requestParams = {
        ...this.SearchData,
        module: this.SearchData.module.join(","),
        ordering: this.Sorting,
        size: this.PageSize,
        page: this.CurrentPage,
      };
      if (this.SearchData.dateRange) {
        requestParams.start_time = this.SearchData.dateRange[0];
        requestParams.end_time = this.SearchData.dateRange[1];
      }
      this.axios
        .get("/api/admin_message/", {
          params: requestParams,
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map(row => {

            try {
              let match_str = row.info.match(/ \{"img_array":.+\}/);
              row.info = row.info.replace(match_str, "");
              row.info_img_array = JSON.parse(match_str[0]).img_array;
            } catch (error) {
              // console.log(error)
            }
            // console.log(row.info_img_array)
            return row;
          });
        });
    },
    change_read(item) {
      this.$prompt("请输入处理结果", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputPattern:
        //   /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: "邮箱格式不正确",
      }).then(({ value }) => {
        this.axios
          .put(`/api/admin_message/${item.id}/change_read/`, {
            remark: value,
          })
          .then(() => {
            this.GetTableList();
          });
      });
    },
    bulk_read() {
      this.axios
        .put(`/api/admin_message/bulk_read/`, {
          id: this.TableList.map((item) => item.id).join(","),
        })
        .then(() => {
          this.GetTableList();
        });
    },
    change_top(item) {
      this.axios.put(`/api/admin_message/${item.id}/change_top/`).then(() => {
        this.GetTableList();
      });
    },

    tableRowClassName({ row }) {
      if (row.is_top) {
        return "is_top";
      } else if (row.is_read) {
        return "is_read";
      }
      return "";
    },

    catchModule() {
      this.$localStorage.set(
        "admin_message_module",
        this.SearchData.module.join(",")
      );
    },
    remoteMethod(query) {
      this.axios
        .get("/api/admin_tenant/simple_list/", {
          params: {
            name: query,
            size: 20,
          },
        })
        .then((data) => {
          this.tenant_list = data.results;
        });
    },
    transformTarget(row) {
      // console.log("row", row);
      var target_module = row.rewrite_module || row.module;
      var record_sign = row.rewrite_record_sign || row.record_sign;

      if (target_module == "quotation") {
        return "/admin/quotation?code=" + record_sign;
      } else if (target_module == "purchase_forging") {
        return "/admin/purchase_forging?code=" + record_sign;
      } else if (target_module == "purchase_material") {
        return "/admin/purchase_material?code=" + record_sign;
      } else if (target_module == "purchase_piece") {
        return "/admin/purchase_piece?code=" + record_sign;
      }
      return false;
    },
    goTransformTarget(row) {
      var target = this.transformTarget(row);
      if (target) {
        this.$openRouter(target);
      }
    },
  },
};
</script>


<style scoped lang="scss">
.moduleContainer {
  width: 100%;
  background: #fff;
  margin-top: 15px;
  padding-bottom: 20px;

  .header {
    padding: 18px 0;
    margin: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    border-bottom: 1px solid $borderPlainColor;

    .title {
      flex-shrink: 0;

      i {
        margin-right: 4px;
        color: $warningColor;
        font-size: 18px;
      }
    }

    .operations {
      display: flex;
      align-items: center;
      flex-grow: 1;
      margin-left: 50px;
    }
  }
}

.businessList {
  font-size: 12px;
  padding: 0 20px;

  .businessItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 15px;

    .date {
      flex-shrink: 0;
      width: 120px;
      color: #999;
      text-align: right;
    }
  }
}

/deep/.el-table {
  .is_read {
    // color: #bbb;
  }

  .is_top {
    background: $warningPlainColor;
    // background: #f5f7fa;
    // color: $warningColor;
    // outline:10px solid red;
  }
}

.credit_level_info {
  display: inline-block;
  margin: 0 auto;
  border-width: 1px;
  border-style: solid;
  line-height: 18px;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 2px;
  cursor: pointer;

  &.danger {
    color: $dangerColor;
    border-color: $dangerColor;
    background: $dangerPlainColor;
  }

  &.warning {
    color: $warningColor;
    border-color: $warningColor;
    background: $warningPlainColor;
  }

  &.success {
    color: $successColor;
    border-color: $successColor;
    background: $successPlainColor;
  }
}
</style>
